import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import HomePage from './pages/HomePage';
import SchedulePage from './pages/SchedulePage';
import AccommodationPage from './pages/AccommodationPage';
import WelcomeGuidePage from './pages/WelcomeGuidePage';
import GalleryPage from './pages/GalleryPage';
import ContactsPage from './pages/ContactsPage';
import RegistrationPage from './pages/RegistrationPage';
import AdminPage from './pages/AdminPage';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  const isHeroPage = ['/', '/schedule', '/accommodation', '/welcome-guide', '/contacts', '/gallery', '/registration', '/admin'].includes(location.pathname);

  return (
    <div className="App">
      <ScrollToTop />
      {!isAdminPage && <Header />}
      <main className={`main-content ${isHeroPage ? 'no-padding' : ''}`}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/schedule" element={<SchedulePage />} />
          <Route path="/accommodation" element={<AccommodationPage />} />
          <Route path="/welcome-guide" element={<WelcomeGuidePage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/registration" element={<RegistrationPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
